import { CategoryModel } from "./CategoryModel";

export interface LevelData {
  /** Database primary key */
  id: number;
  level: number;
  /** Legacy alias for level number used across UI */
  input_level: number;
  nickname: string;
  active: boolean;
  reviewed: boolean;
  categories: Array<{
    group: string;
    name: string;
    necessary: boolean;
    budgeted: number;
    spent: number;
    savings: boolean;
  }>;
  tokens: number;
  weighted_dials: number;
  dial_precision: number;
  dial_visible_categories: number;
  dial_unbalanced_categories: number;
  dial_surprise_events: number;
  dial_steps: number;
  dial_budget: number;
  dial_income: number;
  dial_savings: number;
  dial_surprise_amount: number;
}

export class Level {
  id!: number;
  level!: number;
  /** legacy alias */
  input_level!: number;
  nickname!: string;
  active!: boolean;
  reviewed!: boolean;
  categories!: CategoryModel[];
  tokens!: number;
  weighted_dials!: number;
  dial_precision!: number;
  dial_visible_categories!: number;
  dial_unbalanced_categories!: number;
  dial_surprise_events!: number;
  dial_steps!: number;
  dial_budget!: number;
  dial_income!: number;
  dial_savings!: number;
  dial_surprise_amount!: number;

  constructor(data: LevelData) {
    this.id = data.id;
    this.level = data.level;
    this.input_level = data.input_level;
    this.nickname = data.nickname;
    this.active = data.active;
    this.reviewed = data.reviewed;
    this.categories = data.categories.map(
      (c) =>
        new CategoryModel({
          id: `${this.nickname}-${c.name}`,
          name: c.name,
          necessary: c.necessary,
          budgeted: c.budgeted,
          spent: c.spent,
          group: c.group,
          savings: c.savings,
        } as any),
    );
    this.tokens = data.tokens;
    this.weighted_dials = data.weighted_dials;
    this.dial_precision = data.dial_precision;
    this.dial_visible_categories = data.dial_visible_categories;
    this.dial_unbalanced_categories = data.dial_unbalanced_categories;
    this.dial_surprise_events = data.dial_surprise_events;
    this.dial_steps = data.dial_steps;
    this.dial_budget = data.dial_budget;
    this.dial_income = data.dial_income;
    this.dial_savings = data.dial_savings;
    this.dial_surprise_amount = data.dial_surprise_amount;
  }

  /**
   * Check if win condition is met (budgeted >= spent for each category)
   */
  checkWinCondition(): boolean {
    return this.categories.every(
      (category) => category.budgeted >= category.spent,
    );
  }

  /**
   * Check if a specific category just became balanced/surplus
   */
  checkCategoryBecameBalanced(
    categoryIndex: number,
    previousBudgeted: number,
  ): boolean {
    const category = this.categories[categoryIndex];
    const wasInDeficit = previousBudgeted < category.spent;
    const isNowBalanced = category.budgeted >= category.spent;
    return wasInDeficit && isNowBalanced;
  }
}
